import PropTypes from 'prop-types'
import React from 'react'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Button from 'components/Button'
import moment, { displayFormat, urlFormat } from 'helpers/moment'
import { createNewPath } from 'helpers/components'
import classes from './Date.scss'

import ActionDateRange from 'material-ui/svg-icons/action/date-range'
import DatePicker from 'material-ui/DatePicker'

import shouldDisableDateTest from './shouldDisableDate'

export class DateComponent extends React.Component {
  constructor (props) {
    super(props)

    this.datepicker = null
  }

  shouldDisableDate = date => {
    if (typeof this.props.shouldDisableDate === 'function') return !!this.props.shouldDisableDate(date)
    return shouldDisableDateTest(date)
  };

  onChange = (event = null, date) => {
    date = moment(date)
    if (this.props.onChange && typeof this.props.onChange === 'function') this.props.onChange(event, date)
    const currentPath = this.props.location.pathname
    let path

    if (this.props.baseUrl) path = createNewPath(date, this.props.baseUrl, this.props, { action: this.props.urlAction })
    // replace the known /orders/date with /orders/newDate
    else if (this.props.params.date) path = currentPath.replace(this.props.params.date, date.format(urlFormat))
    // switch urls like /orders/new with /orders/date/new
    else if (currentPath.includes('/new')) path = currentPath.replace('/new', `/${date.format(urlFormat)}/new`)
    else if (currentPath.includes('/list')) path = currentPath.replace('/list', `/${date.format(urlFormat)}/list`)
    // just throw date on the end and hope for the best!
    else path = `${currentPath}/${date}`

    path = path.replace(/\/+$/g, '') // remove trailing slashes
    // append to the end, if it's not already at the end...
    if (this.props.urlAction && path.substr(-(this.props.urlAction.length + 1)) !== `/${this.props.urlAction}`) {
      path += `/${this.props.urlAction}`
    }

    path = path.replace(/\/{2,}/g, '/') // replace 2+ forward slashes in a row
    if (path !== currentPath) this.props.dispatch(push(path))
  };

  formatDate = date => {
    if (this.props.formatDate && typeof this.props.formatDate === 'function') return this.props.formatDate(date)

    if (this.props.textFormat) this.props.textFormat.replaceFormat(moment(date).format(displayFormat))
    return moment(date).format(displayFormat)
  };

  render () {
    return <div className={this.props.className}>
      <Button
        options={['background-grey']}
        callback={() => this.datepicker && this.datepicker.openDialog()}
        onlyOnce={false}
      >
        { // this.formatDate expects a javascript date object
          this.formatDate(moment(this.props.date).toDate())
        }
        <i className={classes.icon}><ActionDateRange /></i>
      </Button>

      <DatePicker
        floatingLabelText='select date'
        textFieldStyle={{ display: 'none' }}
        autoOk
        value={moment(this.props.date).toDate()}
        maxDate={moment('today').add(this.props.isAdmin === false ? 7 : 14, 'days').toDate()}
        minDate={moment('today').subtract(this.props.isAdmin === false ? 2 : 7, 'days').toDate()}
        onChange={this.onChange}
        shouldDisableDate={this.shouldDisableDate}
        formatDate={this.formatDate}
        ref={ref => (this.datepicker = ref)}
      />
    </div>
  }
}

DateComponent.propTypes = {
  date: PropTypes.any,

  onChange: PropTypes.func,
  shouldDisableDate: PropTypes.func,
  formatDate: PropTypes.func,

  className: PropTypes.any,
  textFormat: PropTypes.string,
  baseUrl: PropTypes.string,
  urlAction: PropTypes.string,

  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,

  isAdmin: PropTypes.bool
}

DateComponent.defaultProps = {
  date: 'today'
}

const mapStateToProps = (state, ownProps) => ({})
const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(DateComponent)
)



// WEBPACK FOOTER //
// ./src/components/Date/Date.js